module.exports = __webpack_public_path__ + "media/10.492e9bf4.mp3";